<template>
  <div>

    <va-popover
      :message="tooltip.content"
      :placement="tooltip.placement">

      <span
        class="fa-stack has-badge clickable"
        :class="computedClasses"
        :style="computedStyles"
        :data-count="activeFilters"
        @click.prevent="onFilterPressed">

        <i :class="icon" />

      </span>

    </va-popover>

  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: 'fa fa-filter fa-2x'
    },
    tooltip: {
      type: Object,
      required: false,
      default: function () {
        return {
          content: this.$t('filters.toggle'),
          placement: 'left'
        }
      }
    },
    isActive: {
      type: Boolean,
      required: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    activeFilters: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
    onFilterPressed: function () {
      if (!this.isDisabled) {
        this.$emit('toggle-filters')
      }
    }
  },
  computed: {
    computedStyles: function () {
      if (this.isActive) {
        return {
          color: '#29c4a9'
        }
      }
      return null
    },
    computedClasses: function () {
      let classes = []

      classes.push(this.isActive ? 'has-badge--open' : 'has-badge--closed')

      if (this.isDisabled) {
        classes.push('--disabled')
      }

      return classes
    }
  }
}
</script>
<style lang="scss" scoped>
.fa-stack[data-count].has-badge--open {
  &:after {
    position:absolute;
    right:0%;
    top:0.5%;
    content: attr(data-count);
    font-size:55%;
    padding:.6em;
    border-radius:999px;
    line-height:.75em;
    color: white;
    text-align:center;
    min-width:2em;
    font-weight:bold;
    background: #29c4a9;
  }
}
.fa-stack[data-count].has-badge--closed {
  &:after {
    position:absolute;
    right:0%;
    top:0.5%;
    content: attr(data-count);
    font-size:55%;
    padding:.6em;
    border-radius:999px;
    line-height:.75em;
    color: white;
    text-align:center;
    min-width:2em;
    font-weight:bold;
    background: #6E6E6E;
  }
}
.fa-stack[data-count="0"]:after{
  display: none;
}
</style>
